/**
 * Triggers a browser download for a given Blob
 * @param blob - The Blob to download
 * @param filename - The name for the downloaded file
 */
export function downloadFile(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.style.display = "none";
  anchor.href = url;
  anchor.download = filename;

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  // Clean up the object URL immediately after download
  window.URL.revokeObjectURL(url);
}
